var _defs, _circle, _g, _defs2, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 319 250",
    style: {
      enableBackground: "new 0 0 319 250"
    },
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F0F9FF;}\r\n\t.st1{clip-path:url(#SVGID_4_);}\r\n\t.st2{fill:#E58676;}\r\n\t.st3{fill:#FFE3D1;}\r\n\t.st4{fill:#FFA694;}\r\n\t.st5{fill:#4F332E;}\r\n\t.st6{fill:#EFBCA0;}\r\n\t.st7{fill:#1A8476;}\r\n\t.st8{fill:#8C8F99;}\r\n\t.st9{fill:#B4B2C2;}\r\n\t.st10{fill:#AEB2BE;}\r\n\t.st11{fill:#A7D5F7;}\r\n\t.st12{fill:#076D5C;}\r\n\t.st13{fill:#FFFFFF;}\r\n\t.st14{fill:#ED5702;}\r\n\t.st15{fill:#FABF48;}\r\n\t.st16{fill:#E09819;}\r\n\t.st17{fill:#22231E;}\r\n\t.st18{fill:#FBE6D5;}\r\n\t.st19{fill:#E07D6C;}\r\n\t.st20{fill:#C2573C;}\r\n\t.st21{fill:#502B25;}\r\n\t.st22{fill:#512C26;}\r\n\t.st23{fill:#6D9AFF;}\r\n\t.st24{fill:#3B7DF2;}\r\n\t.st25{fill:#C44405;}\r\n"))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -20.682220458984382, -2.8604021072387695)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 159.5,
    cy: 130,
    r: 120
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M130.9,219.3H79.4c14.8,13.2,32.8,22.9,52.8,27.5L130.9,219.3z",
    style: {
      clipPath: "none",
      fill: "rgb(46, 37, 36)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M274,76.5c-3.5,0-3.5,5.3,0,5.3C277.4,81.8,277.5,76.5,274,76.5z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M265.3,76.5c-3.5,0-3.5,5.3,0,5.3C268.8,81.7,268.8,76.5,265.3,76.5z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M198.8,178.2c-0.6-0.4-1.5-0.2-1.7,0.5c-0.2,0.5-0.1,1-0.1,1.5c0,0.7,0,1.4,0.1,2.1c0,0.3,0.3,0.4,0.6,0.3 c0.1,0.1,0.3,0.2,0.5,0.1C200,182.3,200.1,179.2,198.8,178.2z",
    style: {
      fill: "rgb(163, 58, 51)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M205.4,172.2c-0.1-1.2-0.3-3.4-1.2-4.3c-0.8-0.8-10.7,1.7-10.7,2c-0.1,0.1-0.2,0.3-0.2,0.5 c0.2,3.3-0.5,7.8,2.2,10.3c0.6,0.5,7.9-1,10.5-1.4C206.4,179.2,205.7,174.1,205.4,172.2z",
    style: {
      fill: "rgb(247, 148, 109)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M163.9,178.5c-3.4-5.8-8-12.2-13.5-20.3c-2.9-4.3-11.4-24.4-19.6-27.6c-0.7-0.3-1.6,0.3-1.4,0.8 c-2.9,4.9-3.2,11-3.6,16.5c-0.6,9.5-0.6,17.7,5.3,25.7c5,6.7,14.2,17,23.2,17.5C159.8,191.4,167.7,185,163.9,178.5z",
    style: {
      fill: "rgb(195, 73, 23)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M198.2,182.6c-0.1-0.3-0.2-0.8-0.4-1.1c-4.2-5.2-2.1-12.1-1.5-14.3c0.1-0.3,1.5-0.9,1.5-1.2 c0-0.7-0.6-1.6-1.3-1.5c-12.7,1.4-25.4,2.6-38.1,4.4c-8.5,1.2-16.5,5.7-15.3,15.5c0,0.1,0.1,0.2,0.1,0.3 c-0.2,0.4-1.6,0.2-1.2,0.6c6.3,7.2,16.3,7.2,24.7,5.3C177.2,188.2,198.4,183.1,198.2,182.6z",
    style: {
      fill: "rgb(195, 73, 23)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M189.6,169.8c-1.6,4.4-1,9.3,1.4,13.2c0.4,0.6,1.3,0,0.9-0.5c-2.3-3.7-2.8-8.3-1.3-12.4 C190.9,169.5,189.9,169.2,189.6,169.8L189.6,169.8z",
    style: {
      fill: "rgb(154, 58, 18)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M156.2,169.6c-3.6,1.8-6.2,4.8-7.6,8.6c-0.2,0.6,0.8,0.9,1,0.3c1.3-3.5,3.8-6.3,7.1-8 C157.3,170.2,156.8,169.3,156.2,169.6L156.2,169.6z",
    style: {
      fill: "rgb(154, 58, 18)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M256.1,178.9L140.8,176c-3.7,0-6.5-3.5-5.7-7.1l26.3-115.1c0.6-2.6,2.9-4.4,5.5-4.4h112.2 c3.7,0,6.5,3.5,5.7,7.1l-23.3,118C261,177.1,258.7,178.9,256.1,178.9z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M 256.1 179.5 C 256.1 179.5 140.8 176.6 140.8 176.6 C 138.9 176.6 137 175.7 135.8 174.2 C 134.60000000000002 172.7 134.10000000000002 170.7 134.60000000000002 168.79999999999998 L 160.90000000000003 53.69999999999999 C 161.60000000000002 50.79999999999999 164.10000000000002 48.89999999999999 167.00000000000003 48.89999999999999 L 279.20000000000005 48.89999999999999 C 281.20000000000005 48.89999999999999 283.00000000000006 49.79999999999999 284.20000000000005 51.29999999999999 C 285.40000000000003 52.79999999999999 285.90000000000003 54.79999999999999 285.40000000000003 56.69999999999999 L 262.1 174.7 C 261.5 177.5 259 179.5 256.1 179.5 Z",
    style: {
      fill: "rgb(176, 231, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M 167 50 C 164.6 50 162.6 51.6 162 53.9 L 135.7 169 C 135.29999999999998 170.5 135.7 172.1 136.7 173.4 C 137.7 174.70000000000002 139.2 175.4 140.79999999999998 175.4 L 256 178.3 C 258.4 178.3 260.4 176.70000000000002 261 174.4 L 284.3 56.400000000000006 C 284.7 54.800000000000004 284.3 53.2 283.3 52.00000000000001 C 282.3 50.70000000000001 280.8 50.00000000000001 279.2 50.00000000000001 L 167 50.00000000000001 L 167 50 Z",
    style: {
      fill: "rgb(176, 231, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M164.4,114.7c25.2,0,50.4,0,75.7,0c6.2,0,12.4,0,18.5,0c0.7,0,0.7-1,0-1c-25.2,0-50.4,0-75.7,0 c-6.2,0-12.4,0-18.5,0C163.8,113.6,163.8,114.7,164.4,114.7L164.4,114.7z",
    style: {
      fill: "rgb(176, 231, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M162.4,122.2c25.2,0,50.4,0,75.7,0c6.2,0,12.4,0,18.5,0c0.7,0,0.7-1,0-1c-25.2,0-50.4,0-75.7,0 c-6.2,0-12.4,0-18.5,0C161.8,121.2,161.8,122.2,162.4,122.2L162.4,122.2z",
    style: {
      fill: "rgb(176, 231, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M160.3,129.8c25.2,0,50.4,0,75.7,0c6.2,0,12.4,0,18.5,0c0.7,0,0.7-1,0-1c-25.2,0-50.4,0-75.7,0 c-6.2,0-12.4,0-18.5,0C159.7,128.7,159.7,129.8,160.3,129.8L160.3,129.8z",
    style: {
      fill: "rgb(176, 231, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M158.9,136.4c25.2,0,50.4,0,75.7,0c6.2,0,12.4,0,18.5,0c0.7,0,0.7-1,0-1c-25.2,0-50.4,0-75.7,0 c-6.2,0-12.4,0-18.5,0C158.2,135.4,158.2,136.4,158.9,136.4L158.9,136.4z",
    style: {
      fill: "rgb(176, 231, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M157.5,143.1c25.2,0,50.4,0,75.7,0c6.2,0,12.4,0,18.5,0c0.7,0,0.7-1,0-1c-25.2,0-50.4,0-75.7,0 c-6.2,0-12.4,0-18.5,0C156.8,142.1,156.8,143.1,157.5,143.1L157.5,143.1z",
    style: {
      fill: "rgb(176, 231, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M209.4,67.2c20.2,0,40.4,0.1,60.6,0.1c0.7,0,0.7-1,0-1c-20.2,0-40.4-0.1-60.6-0.1 C208.8,66.2,208.8,67.2,209.4,67.2L209.4,67.2z",
    style: {
      fill: "rgb(176, 231, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M207.4,74.7c20.2,0,40.4,0.1,60.6,0.1c0.7,0,0.7-1,0-1c-20.2,0-40.4-0.1-60.6-0.1 C206.7,73.7,206.7,74.7,207.4,74.7L207.4,74.7z",
    style: {
      fill: "rgb(176, 231, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M210.5,160.2c12.1,0,24.1,0.1,36.2,0.1c0.7,0,0.7-1,0-1c-12.1,0-24.1-0.1-36.2-0.1 C209.8,159.1,209.8,160.2,210.5,160.2L210.5,160.2z",
    style: {
      fill: "rgb(255, 220, 108)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M206,82.4c20.2,0,40.4,0.1,60.6,0.1c0.7,0,0.7-1,0-1c-20.2,0-40.4-0.1-60.6-0.1 C205.3,81.4,205.3,82.4,206,82.4L206,82.4z",
    style: {
      fill: "rgb(176, 231, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M204.7,90.7c19.7,0,39.4,0,59.2,0c0.7,0,0.7-1,0-1c-19.7,0-39.4,0-59.2,0C204,89.7,204,90.7,204.7,90.7 L204.7,90.7z",
    style: {
      fill: "rgb(176, 231, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M167.8,98.6c25.2,0,50.4,0,75.7,0c6.2,0,12.4,0,18.5,0c0.7,0,0.7-1,0-1c-25.2,0-50.4,0-75.7,0 c-6.2,0-12.4,0-18.5,0C167.1,97.6,167.1,98.6,167.8,98.6L167.8,98.6z",
    style: {
      fill: "rgb(176, 231, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M165.6,106.8c25.2,0,50.4,0,75.7,0c6.2,0,12.4,0,18.5,0c0.7,0,0.7-1,0-1c-25.2,0-50.4,0-75.7,0 c-6.2,0-12.4,0-18.5,0C165,105.7,165,106.8,165.6,106.8L165.6,106.8z",
    style: {
      fill: "rgb(176, 231, 255)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M202,64h-24.1c-0.7,0-1.4,0.5-1.5,1.2l-5.5,24.1c-0.2,0.9,0.5,1.8,1.4,1.8h24.1c0.7,0,1.4-0.5,1.5-1.2 l5.5-24.1C203.6,64.8,202.9,64,202,64z",
    style: {
      fill: "rgb(255, 220, 108)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M212.4,161c2.9-3.8,6.2-7.3,10-10.2c0.9-0.7,2-1.5,3.2-1.6c0.9,0,1.4,0.2,1.8,1c0.4,0.9,0.2,1.5-0.2,2.4 c-0.9,2-3,4.3-5.4,4.3c-1,0-1.2-0.6-0.6-1.3c0.3-0.4,1.1-0.8,1.6-1c1-0.5,2.4-1.1,3.5-1c0.9-0.2,1.4,0.3,1.6,1.6 c-0.2,0.2-0.3,0.4-0.5,0.6c-0.3,0.4-0.6,0.7-0.8,1.2c-0.1,0.4-0.2,0.7,0.1,1c0.7,0.8,3,0.1,3.8-0.2c1.9-0.5,3.5-1.4,5-2.7 c-0.2-0.1-0.5-0.3-0.7-0.4c-0.4,2,2.1,2.1,3.5,2c2.4-0.2,4.7-1,6.7-2.4c0.5-0.3,0-1.1-0.4-0.7c-1.2,0.8-2.6,1.4-4,1.8 c-0.6,0.2-5.3,1.2-4.9-0.5c0.1-0.4-0.4-0.7-0.7-0.4c-1,0.9-2.2,1.6-3.5,2.1c-0.6,0.2-3.6,1.2-3.8,0.6 c-0.2-0.6,1.2-1.8,1.4-2.5c0.1-0.6,0-1.2-0.4-1.6c-1.2-1.2-4.2-0.3-5.5,0.3c-1,0.4-3.5,1.6-3.4,3.1c0.2,1.6,2.9,1.3,3.9,0.9 c1.8-0.7,3.3-2.3,4.2-4c0.7-1.3,1.4-3.1,0.2-4.3c-1.1-1-2.9-0.9-4.2-0.3c-2.4,1.2-4.6,3.5-6.4,5.3c-2,2-3.9,4.1-5.6,6.4 C211.3,161,212.1,161.5,212.4,161L212.4,161z",
    style: {
      fill: "rgb(84, 144, 252)"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M208.3,155.6l-9.9-16.6c-0.1-0.2-0.2-0.4-0.4-0.5c0,0-77.3-86-92.1-102.5c2.9-0.4,5.9,2.9,7.6,4.9 c2.4,2.9,18.1,20.1,23.9,25.5c2.1,2,5.4-1.2,3.2-3.2c-7.5-7.1-13.9-14-21.3-22.4c-4.2-4.7-10.2-12-16.7-8.4 c-0.6-0.7-5.6-6.3-5.6-6.3c-0.4-0.7-1.9-0.8-2.4-0.7c-2.2,0.4-4.3,2-5.7,3.7c-1.2,1.4-2.8,3.6-1.2,5.3 c0.1,0.1,100.8,112.2,100.8,112.2c0.2,0.3,0.5,0.5,0.8,0.6l17.7,9.5C207.9,157.1,208.7,156.3,208.3,155.6z",
    style: {
      fill: "rgb(109, 154, 255)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M107.7,94.8c-3.1-2.2-6.9-2.7-10.5-1.6c-0.7,0.2-0.4,1.4,0.3,1.1c3.3-1.1,6.8-0.6,9.6,1.4 C107.7,96.3,108.3,95.3,107.7,94.8L107.7,94.8z",
    style: {
      fill: "rgb(219, 157, 105)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M87,122.9c2,2.4,6.5,3,9.3,2.6c3.2-0.4,6.1-2,8.2-4.4c0-0.6,0-1.2-0.1-1.8c-0.2-2.7-0.3-5.4-0.4-8.2 c0-0.1,0-0.2-0.1-0.3c0-0.2,0-0.4-0.1-0.6c-2.2-5.2-4.5-11.8-8.9-15.6c-1.3-1.2-3.4-2.5-5.2-2.4c-1.5,0.1-2.4,1.3-3.3,2.5 c-0.8-0.1-1.5,0.3-1.4,1.3c0.5,5.8,1.2,11.5,1.5,17.3C86.7,118,86.9,120.9,87,122.9z",
    style: {
      fill: "rgb(247, 148, 109)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M108.8,124.4c-1.5-0.6-3.5-1.8-5.1-1.8c-1.5,0-3.2,1.3-4.5,1.8c-4.5,1.5-9.5,0-14-0.7 c-0.3,0-0.4,0.2-0.4,0.3c-2.5,0.8-5,1.8-7.4,2.9c-0.1,0.1-0.2,0.3-0.2,0.4c2.7,7.7,5.5,15.4,8.2,23.1c0.6,1.8,1.2,3.6,1.9,5.3 c0.4,0.9,0.8,2.4,1.9,2.4c0.7,0,1.3-0.5,1.7-1c1.3-1.5,2.3-3.4,3.5-5.1c4.1-6.1,7.6-12.9,12.5-18.5c1-1.2,2.2-2.3,3.4-3.3 c0.9-0.7,5.4-0.6,5.9-1.7C117,126.5,109.9,124.8,108.8,124.4z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M110,106.1c0-3.6,0.1-7.3-0.2-11c-0.4-5.3-2.4-10.7-7.4-13.1c-3.6-1.8-8.3-2.4-12.2-1 c-2.1,0.7-3.4,2.1-5,3.7c-2,1.9-3.2,4.5-3.3,7.3c0,0.2,0,0.3,0,0.5c0,3,1.2,5.3,3,7.3c0.2,2.3,2.9,10.2,3.7,12.5 c0.2,0.5,0.5,0.9,1,1.2c2.6,1.5,7.6,2.1,10.2,2.4c2.9,0.3,6,0.1,8.1-2.2C109.8,111.7,110,108.8,110,106.1z",
    style: {
      fill: "rgb(247, 148, 109)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M105.3,117.3c-0.3-0.6-1.1-0.8-1.2-0.3c-0.3,3.7-5.7,6.2-9.9,7.3c-0.3,0.1,0,0.8,0,1c0,0.1-0.1,0.3,0,0.4 c0.4,2,1.1,4,2.1,5.8c0.1,0.2,0.3,0.3,0.4,0.3c0.2,0.1,0.4,0.2,0.6,0.2c4.7-0.7,9-3.9,10.1-7.9 C107.6,123.7,106.2,119.1,105.3,117.3z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M69.7,130.6c-0.2-0.4-0.6-2.1-1.1-1.8c-7.4,3.5-10.6,5.8-14,10.8c-4.4,6.2-8.2,13.3-11.8,20 c-2.2,4.1-4.5,8.2-6.3,12.6c-1.8,4.4-4.2,10.2-2.6,15c1.8,5.4,13.3,7.2,16.3,2.2c4.5-7.5,11.6-18.1,15.4-26 C69.4,155.7,71.3,130.3,69.7,130.6z",
    style: {
      fill: "rgb(195, 73, 23)"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M93.6,127.4c-2.1,10.9-3.2,22.1-3,33.2c0,0.7,1,0.7,1,0c-0.1-11,0.9-22.1,3-32.9 C94.7,127,93.7,126.7,93.6,127.4L93.6,127.4z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M94.5,124.7c0-0.1-0.1-0.3-0.2-0.4c-3.3-1.1-7.3-2.7-7.5-6.7c0-0.7-0.7-0.4-0.8-0.1 c-0.6,1.4-2.1,5.8-2.2,7.3c0,0.3-0.2,1.2,0,1.6c1.2,2.7,4,5,7.3,5.2c0.2,0,0.4-0.2,0.4-0.3c1.3-1.9,2.4-4,3.2-6.2 C94.7,124.9,94.6,124.7,94.5,124.7z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_1_",
    cx: 159.5,
    cy: 130,
    r: 120
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 159.5,
    cy: 130,
    r: 120,
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M131.8,165.8c-3-9.1-4.9-24.1,5.2-28.5c-1.2-2.4-2.8-4.5-5-5.9c-3.1-2-6.8-3.3-10.3-4.4 c-1.9-0.6-8.6-2.8-9.6-1.8c-16.9,15.5-29.3,12-30.5,0.6c0-0.1,0-0.2,0-0.3c0-0.3-0.1-0.5-0.3-0.6c-0.2-0.4-11.5,3-16.5,5.8 c-4.1,2.3-8.4,6.6-9.9,8.5c-0.3,0.4-0.2,0.8,0,1.1c0,0.1,0,0.2,0,0.3c0.8,8,2.7,15.7,5.6,23c0.3,10.6,1.8,51.8,3.7,62.2 l66.7,0.4c1.3-6.8,2.5-45.5,3.6-52.9C133.5,170.7,132.6,168.2,131.8,165.8z",
    style: {
      clipPath: "url('#SVGID_2_')",
      fill: "rgb(195, 73, 23)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M126.3,147c-0.8,4.9-0.9,9.9,0.2,14.8c1.1,5,3.4,9.6,6.3,13.7c0.4,0.5,1.3,0,0.9-0.5c-2.8-4-5-8.3-6.1-13 c-1.1-4.8-1.1-9.8-0.3-14.7C127.4,146.6,126.4,146.3,126.3,147L126.3,147z",
    style: {
      fill: "rgb(154, 58, 18)"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M93.8,125.5c0.2,1.9,0.7,4.8,2.2,6.2c0.8,0.7,1.9,0.4,2.8,0.1c3.5-1.1,6.6-3.4,8.7-6.4 c0.4-0.6-0.5-1.1-0.9-0.5c-1.8,2.5-4.3,4.4-7.2,5.6c-0.5,0.2-1.4,0.7-2,0.6c-1.8-0.1-2.5-4.2-2.6-5.6 C94.8,124.8,93.8,124.8,93.8,125.5L93.8,125.5z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M93.7,125.4c-0.3,0.9-0.6,1.8-0.9,2.6c-0.3,0.8-0.9,2.5-1.8,2.7c-0.6,0.1-2.1-0.9-2.6-1.2 c-0.7-0.4-1.3-0.9-1.8-1.4c-0.8-0.8-1.3-1.8-1.9-2.7c-0.4-0.6-1.3,0-0.9,0.5c0.8,1.2,1.5,2.4,2.5,3.4c0.7,0.6,1.5,1.2,2.3,1.6 c0.7,0.4,1.7,1,2.5,1c2.2-0.2,3-4.5,3.6-6.1C94.9,125.1,93.9,124.8,93.7,125.4L93.7,125.4z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M221.2,169.5c0-0.1-0.1-0.2-0.2-0.3c-0.7-1.4-2.8-2.4-4-1c-0.4-1.7-1.5-3.1-3.4-3.2c-1.4,0-2.1,0.7-2.4,1.7 c-0.1-0.2-0.3-0.3-0.5-0.4c-0.6-0.3-1.4-0.2-2,0c-1,0.3-1.4,1-1.6,1.8c0.1-0.5-1.6-0.2-1.7-0.1c-2.1,0.8-1.6,2.8-1.8,4.7 c-0.2,2.1-1.8,5.8-3.9,6.1c-1.3,0.2-0.3-0.6,0.5-0.1c0,0.4,0.8,1.1,1.5,1.2c5.5,0.7,10.9-0.2,15.7-2 C221.9,176.3,222.3,173.1,221.2,169.5z",
    style: {
      fill: "rgb(247, 148, 109)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M99.4,178.5c-2.3-1.4-1.5,5.5-1.5,6.2c0,0.1,0.1,0.2,0.2,0.3c0.1,0.1,0.4,0.3,0.6,0.2 c1.3-0.5,1.4-2.2,1.5-3.5C100.3,180.8,100.3,179.1,99.4,178.5z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M207.2,170c0.3,2.4,0.8,5.8-1.9,7c-0.6,0.3-0.1,1.2,0.5,0.9c3.1-1.4,2.7-5,2.4-7.9 C208.2,169.4,207.2,169.4,207.2,170L207.2,170z",
    style: {
      fill: "rgb(203, 91, 69)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M128.9,165.1c0-0.1-0.1-0.2-0.2-0.3c-1.1-1.1-2.2-0.4-3.4,0.1c-2.4,1.2-4.9,2.2-7.5,2.9 c-0.8,0.2-4,1.2-5.4,0.8c-0.4-0.1-0.4-0.7,0-0.8c1.9-0.6,5.7-0.9,5.5-3.3c0-0.4-0.4-0.8-0.9-0.8c-2.9,0.3-7.3,0.3-10.2,1.1 c-1.4,0.4-2.7,1.1-3.8,2.1c-1.1,1-1.7,2.5-2.9,3.5c-0.2,0.2-0.4,0.2-0.6,0.3c-2.4,0.1-6.3,0.1-6.5,0.4 c-2.5,2.8-1.6,10.9-1.6,10.8c0.1,0,0.1,0,0.2,0c2.6-0.3,9.4-0.8,10.9-0.7c2.8,0.2,6.1,0.4,8.9-0.2c3.6-0.8,7.1-2,10.2-4 c1.5-1,3.6-3,4.7-4.4c0.9-1.2,2.2-3,1-4.2c0,0-0.1-0.1-0.1-0.1c0.7-0.8,1.4-1.7,1.8-2.7C129.1,165.5,129,165.3,128.9,165.1z",
    style: {
      fill: "rgb(247, 148, 109)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M99.6,170.2c-0.9-0.3-2.1,0-3,0c-0.1,0,0.3-0.5,0.2-0.5c0,0,0,0,0,0c-3.3-0.1-4.7,3.1-5.4,5.8 c-1,3.7-0.8,7.5,0.3,11.1c0.1,0.4,0.8,0.3,0.7-0.2c0-0.1-0.1-0.2-0.1-0.4c0.1,0.1,0.1,0.1,0.3,0.1c2-0.2,4-0.6,6-1 c0.2,0,0.3-0.3,0.3-0.5c-1.2-4.7-0.9-9.6,1-14.1C100,170.4,99.8,170.2,99.6,170.2z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M211.2,168.1c0.4,2.7,0.7,5.5-1,7.9c-0.4,0.5,0.5,1.1,0.9,0.5c1.9-2.6,1.6-5.7,1.1-8.7 C212.1,167.2,211.1,167.5,211.2,168.1L211.2,168.1z",
    style: {
      fill: "rgb(203, 91, 69)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M216.5,169.2c0.7,1.9,1.1,4.1-0.4,5.7c-0.4,0.5,0.3,1.2,0.7,0.7c1.7-1.9,1.5-4.5,0.7-6.8 C217.3,168.4,216.3,168.6,216.5,169.2L216.5,169.2z",
    style: {
      fill: "rgb(203, 91, 69)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M98.1,169.9c0.1-0.6-0.2-1.2-1-1.2c-12.1,0.5-41.3,0.7-46.4,1.6c-2.5,0.5-5.2,1-7.1,2.8 c-5.2,4.7-7.6,16.8-4,18.5c3.9,1.9,39.2,0.1,53.9-2.9c0.6-0.1,1.5-0.6,1.4-1.1C94.9,187.6,91.4,178.2,98.1,169.9z",
    style: {
      fill: "rgb(195, 73, 23)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M98,169.1c-0.9-1.1-2.2-1.3-3.6-1.4c-2.2-0.2-4.4-0.2-6.6-0.2c-4.5,0-9,0.3-13.5,0.5 c-4.3,0.2-8.6,0.4-12.9,0.6c-4.2,0.2-8.5,0.2-12.6,1.3c-0.6,0.2-0.4,1.2,0.3,1c3.9-1.1,8-1.1,12-1.3c4-0.2,8-0.4,12-0.6 c4-0.2,8-0.4,12-0.5c2.1-0.1,4.2-0.1,6.3,0c1.8,0.1,4.5-0.2,5.7,1.3C97.6,170.4,98.4,169.6,98,169.1L98,169.1z",
    style: {
      fill: "rgb(154, 58, 18)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M59.4,151.6c0.1,5.8,0.7,11.6,1.7,17.3c0.1,0.7,1.1,0.4,1-0.3c-1-5.6-1.5-11.3-1.7-17.1 C60.4,151,59.3,151,59.4,151.6L59.4,151.6z",
    style: {
      fill: "rgb(154, 58, 18)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M65.1,192.7c5.9-0.6,11.8-1.1,17.7-1.9c2.7-0.3,5.4-0.7,8-1.2c1.8-0.3,4.3-0.2,4.8-2.4 c0.1-0.7-0.9-0.9-1-0.3c-0.3,1.4-2.2,1.3-3.3,1.5c-1.2,0.2-2.3,0.4-3.5,0.6c-2.6,0.4-5.1,0.7-7.7,1c-5,0.6-10,1-15,1.5 C64.5,191.7,64.5,192.8,65.1,192.7L65.1,192.7z",
    style: {
      fill: "rgb(154, 58, 18)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M87.1,98.7c-0.1-2.1-0.3-4.2-0.8-6.2c-0.1-0.4-0.4-0.6-0.7-0.6c-0.9-1.5-3.7-2.8-5.1-1.6 C79.7,91,80,92.3,80,93.2c0.2,2,4.3,10.3,6.3,8.9C87.4,101.4,87.1,99.8,87.1,98.7z",
    style: {
      fill: "rgb(255, 211, 135)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M126.1,168.8c-3,1.9-6.4,3.1-10,3.5c-0.7,0.1-0.7,1.1,0,1c3.8-0.4,7.3-1.6,10.5-3.6 C127.2,169.4,126.6,168.5,126.1,168.8L126.1,168.8z",
    style: {
      fill: "rgb(203, 91, 69)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M87.1,102.1c-0.6-3.1-2.2-6.4-4.2-5.1c-1.9,1.2-0.8,5-0.2,6.7c0.6,1.5,3.1,5.5,4.4,2.4 C87.4,105.2,87.4,103.7,87.1,102.1z",
    style: {
      fill: "rgb(247, 148, 109)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M109.8,84.2c-0.1-0.1-0.2-0.3-0.2-0.5c-0.2-1.8-1.4-3.6-3.3-4.5c-5.4-2.8-12.7-1.1-17.8,1.3 c-0.1,0-0.1,0-0.2,0.1c-3.5,0.5-6.9,1.4-8.9,4.5c-1.3,1.9-1.5,4.8-0.6,6.9c1.2,3,5,3.1,7.4,1.5c1.5-1,2.4-2.4,2.9-4 c0.1-0.4,0.5-0.7,1-0.6c1.8,0.4,3.6,0.5,5.6,0.2c1.7-0.2,1.5-1,3.7-0.1c0.7,0.3,1.3,1.1,2.1,1.4c1.3,0.6,2.7,0.9,4.1,0.9 C110.3,91.3,113.1,87.4,109.8,84.2z",
    style: {
      fill: "rgb(255, 211, 135)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M85.7,93.1c-1.2,0.7-2.5,0.9-3.8,0.6c-0.7-0.2-1,0.9-0.3,1.1c1.6,0.4,3.3,0.1,4.7-0.7 C86.9,93.7,86.3,92.7,85.7,93.1L85.7,93.1z",
    style: {
      fill: "rgb(219, 157, 105)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M97.8,98c-0.5-0.3-1,0-1.2,0.4c-1.4,2.4,1.9,4.9,2.2,1.7C98.8,99.3,98.4,98.3,97.8,98z",
    style: {
      fill: "rgb(46, 6, 10)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M106.9,97.3c-0.4-0.3-0.9-0.1-1.1,0.3c-1.5,2.2,1.1,5.1,1.7,1.9C107.6,98.7,107.4,97.7,106.9,97.3z",
    style: {
      fill: "rgb(46, 6, 10)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M87.4,107.3c0.5,1.3,1.2,2.5,1.9,3.7c0.5,0.9,1.1,2,1.8,2.7c2.5,2.4,7.3,3.5,10.6,2.6 c0.6-0.2,0.4-1.2-0.3-1c-1.8,0.5-3.6,0.3-5.4-0.3c-1.4-0.4-3.3-1.1-4.3-2.2c-0.7-0.7-1.2-1.8-1.7-2.6c-0.6-1-1.2-2.1-1.6-3.2 C88.2,106.4,87.2,106.6,87.4,107.3L87.4,107.3z",
    style: {
      fill: "rgb(203, 91, 69)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M103.8,100.1c0.5,0.3,0.8,0.7,0.7,1.3c-0.1,0.6-0.6,0.9-1.1,1.1c-0.6,0.3-0.1,1.2,0.5,0.9 c0.8-0.4,1.5-1.1,1.6-2.1c0.1-0.9-0.4-1.8-1.3-2.2C103.7,98.9,103.2,99.8,103.8,100.1L103.8,100.1z",
    style: {
      fill: "rgb(203, 91, 69)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M101.6,103c0.1-0.1,0.2-0.1,0.4-0.1c0.6,0.2,0.9-0.8,0.3-1c-0.5-0.1-1,0-1.4,0.4 C100.4,102.7,101.2,103.5,101.6,103L101.6,103z",
    style: {
      fill: "rgb(203, 91, 69)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M83.4,99.9c0.6,0.7,1,1.5,1.3,2.4c0.2,0.6,1.2,0.4,1-0.3c-0.3-1.1-0.8-2.1-1.5-2.9 C83.7,98.6,83,99.4,83.4,99.9L83.4,99.9z",
    style: {
      fill: "rgb(203, 91, 69)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M109,95.4c-0.1-1.7-2.3-2.4-3.7-1.6c-0.8,0.5-1.4,1.9-0.4,2.5c0.5,0.3,1.4-0.1,2-0.1 c0.5,0,0.9,0.1,1.4,0.2C109.1,96.7,109,95.9,109,95.4z",
    style: {
      fill: "rgb(255, 211, 135)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M100.1,95.4c-0.9-2.7-6.2-1.4-6.2,1.2c-0.1,0.1-0.1,0.2-0.1,0.3c0.5,1.7,2.3,0.4,3.3,0.2 C98.3,96.9,100.8,97.5,100.1,95.4z",
    style: {
      fill: "rgb(255, 211, 135)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M105.7,104.4c-0.1-0.1-0.2-0.1-0.4-0.1c-1.1,0.4-2.2,0.5-3.3,0.5c-0.6,0-2.1-0.4-2.1,0.6c0,1.4,2,1.7,3,1.6 c1.5-0.1,2.9-0.7,3-2.4C106,104.5,105.8,104.4,105.7,104.4z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M108.3,82.9c-0.5-1.4-1.6-2.5-3-3.1c-0.8-0.3-1.6-0.4-2.4-0.3c-0.5,0-1,0.2-1.5,0.3 c-0.2,0.1-0.8,0.4-1,0.4c-0.6,0-1.4-0.8-1.9-1c-0.7-0.3-1.5-0.4-2.2-0.4c-1.6,0-3.1,0.7-4.2,1.8c-0.5,0.5,0.3,1.3,0.8,0.8 c1-1,2.4-1.5,3.8-1.5c0.7,0,1.5,0.2,2.1,0.6c0.4,0.2,0.8,0.7,1.3,0.8c0.2,0.1,0.5,0,0.7-0.1c0.8-0.2,1.4-0.6,2.3-0.7 c1.8-0.2,3.6,0.7,4.2,2.5C107.4,83.9,108.6,83.6,108.3,82.9L108.3,82.9z",
    style: {
      fill: "rgb(219, 157, 105)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M103,33.6c0.6,0.6,1.2,1.2,1.8,1.8c0.5,0.5,1.2-0.3,0.7-0.7c-0.6-0.6-1.2-1.2-1.8-1.8 C103.3,32.4,102.5,33.1,103,33.6L103,33.6z",
    style: {
      fill: "rgb(84, 144, 252)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M95.4,26.5c0.2,1.5-1.7,3.2-2.8,4c-1.1,0.8-2.4,1.3-3.7,1.5c-0.7,0.1-0.4,1.1,0.3,1c1.9-0.3,3.6-1.2,5-2.5 c1.2-1.1,2.5-2.6,2.2-4.4C96.3,25.6,95.3,25.9,95.4,26.5L95.4,26.5z",
    style: {
      fill: "rgb(84, 144, 252)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M196,138.1c0.7,2.9-2.6,6.2-5.4,6.4c-0.7,0.1-0.7,1.1,0,1c3.5-0.3,7.3-4.1,6.4-7.7 C196.8,137.2,195.8,137.5,196,138.1L196,138.1z",
    style: {
      fill: "rgb(84, 144, 252)"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSign);
export default __webpack_public_path__ + "static/media/sign.5aead6f00b5b39dbe3601e52ad8bbe90.svg";
export { ForwardRef as ReactComponent };